import { defineStore } from 'pinia';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { IsnippetStrapiResponse } from '~/types/snippet';

export const useStoreSnippet = defineStore('snippet', {
  state: () => ({
    data: {} as Record<string, number>,
    requestPromise: null as Promise<IsnippetStrapiResponse> | null,
  }),

  actions: {
    async loadSnippets() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['snippets']);

        this.requestPromise = strapi()
          .get('snippet', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        if (response.data.snippets) {
          this.data = response.data.snippets.reduce((result, item) => {
            if (item && item?.currency) {
              result[item.currency] = Number(item?.eurEquivalent);
            }
            return result;
          }, {} as Record<string, number>);
        }

        return true;
      } else {
        return false;
      }
    },
  },
});
